import React, { useEffect, useState } from 'react';
import Modal from '../../components/Modal';
import { getBillingTypeDisplayName } from '../../util/gearOrderUtil';
import AlertMessage from '../../AlertMessage';

/**
 * A modal to select the billing method
 */
const BillingMethodModal = ({ billingOptions, selectedBillingMethod, onModalHidden, onSave }) => {
	const [billingMethod, setBillingMethod] = useState(selectedBillingMethod || '');
	const [partialSupport, setPartialSupport] = useState(false);

	const handleSave = () => onSave(billingMethod);
	const changeBilling = (e) => {
		setBillingMethod(e?.target?.value || '');
	};

	// Show a message if any product in the bundle does not support the selected billing method
	useEffect(() => {
		setPartialSupport(
			!!(billingMethod && billingOptions?.find((option) => option.name === billingMethod)?.partialSupport)
		);
		// const selectedBillingOption = billingOptions?.find((option) => option.name === billingMethod);
		// setPartialSupport(
		// 	!!(
		// 		billingMethod &&
		// 		(!selectedBillingOption ||
		// 			billingOptions?.find((option) => option.name === billingMethod)?.partialSupport)
		// 	)
		// );
	}, [billingMethod, billingOptions]);

	return (
		<Modal
			id={`billing-customization-modal`}
			displayProps={{ modalContent: { className: 'modal-content modal-scroll' } }}
			title="Select a Billing Method"
			confirmAction="Save"
			cancelAction="Cancel"
			onSave={handleSave}
			modalHidden={onModalHidden}
		>
			{partialSupport && (
				<AlertMessage type="info" additionalCssClass="mt-0">
					One or more of the products on your custom profile does not support the selected billing method. You
					will be required to choose a billing method when placing an order.
				</AlertMessage>
			)}
			<div className="mt-20">
				<div className="list-group">
					{billingOptions.map(function (option) {
						const optionName = getBillingTypeDisplayName(option.name);
						return (
							<label
								className={'list-group-item ' + (billingMethod === option.name ? 'active' : '')}
								key={option.name}
							>
								<div>
									<div>
										<input
											type="radio"
											value={option.name}
											name="billingOptions"
											onChange={changeBilling}
											checked={billingMethod === option.name}
										/>
										<div className="billing-option-text">
											<h4 className="list-group-item-heading control-label">{optionName}</h4>
											{!!option.description && (
												<p className="list-group-item-text">{option.description}</p>
											)}
										</div>
									</div>
								</div>
							</label>
						);
					})}
				</div>
			</div>
		</Modal>
	);
};

export default BillingMethodModal;
